import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumb({ items }) {
  return (
    <nav data-testid="breadcrumb" className="flex items-center gap-1.5 text-sm text-[#3A4D3E] flex-wrap">
      <Link to="/" className="hover:text-[#1D6B2A]">Home</Link>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <ChevronRight size={14} className="text-[#3A4D3E]/50" />
          {it.to ? (
            <Link to={it.to} className="hover:text-[#1D6B2A]">{it.label}</Link>
          ) : (
            <span className="text-[#0A1C0E] font-medium">{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
